// Per-dialect rename-emitter dispatch.
//
// Slice 27 (this file) wires the contract; Slices 29–33 fill in each
// per-engine emitter so the planner produces real ALTER syntax. The
// `getRenameEmitter(engineId)` lookup is a `DatabaseEngineId → emitter` map;
// `mock` is unsupported (no objects to rewrite). Callers should fall back to
// a "no rewrite needed" no-op object-edit list when the engine is `mock`.

import type { DatabaseEngineId } from '@/core/engines';

import { mssqlRenameEmitter } from './mssql';
import { mysqlRenameEmitter } from './mysql';
import { oracleRenameEmitter } from './oracle';
import { postgresRenameEmitter } from './postgres';
import { sqliteRenameEmitter } from './sqlite';
import type { DialectRenameEmitter } from './types';

export type { DialectRenameEmitter, EmitObjectBodyAlterInput } from './types';
export {
  isStubAlterSql,
  isUnrewritableRenameSql,
  unrewritableRenameReason,
} from './types';

export function getRenameEmitter(
  engineId: DatabaseEngineId,
): DialectRenameEmitter | null {
  switch (engineId) {
    case 'mssql':
      return mssqlRenameEmitter;
    case 'pgsql':
      return postgresRenameEmitter;
    case 'mysql':
      return mysqlRenameEmitter;
    case 'oracle':
      return oracleRenameEmitter;
    case 'sqlite':
      return sqliteRenameEmitter;
    case 'mock':
    case 'kusto':
    case 'azurestorage':
      return null;
  }
}
